import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { ExpirationWidget } from "../components/ExpirationWidget";

export const getRequirementExpirationWidget = (
  requirement: IRequirementResponse
) => {
  const expirationDate = requirement.expiresAt;

  if (!expirationDate) {
    return null;
  }

  return <ExpirationWidget expirationDate={expirationDate} />;
};
